/* arbz.js — sliders, menu arrows, hero, AJAX add-to-cart, localization */
(function(){
  if (window.__arbzInit) return; window.__arbzInit = true;

  function initSliders(root){
    (root||document).querySelectorAll('[data-arbz-slider]').forEach(function(sl){
      if (sl.__arbz) return; sl.__arbz = true;
      var track = sl.querySelector('.arbz-track');
      var prev = sl.querySelector('[data-arbz-prev]');
      var next = sl.querySelector('[data-arbz-next]');
      if (!track) return;
      function step(){ var c = track.firstElementChild; return c ? (c.getBoundingClientRect().width + 16) * Math.max(1, Math.floor(track.clientWidth / (c.getBoundingClientRect().width + 16)) - 0) : track.clientWidth; }
      function upd(){
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function(){ track.scrollBy({left: -step(), behavior: 'smooth'}); });
      if (next) next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior: 'smooth'}); });
      track.addEventListener('scroll', upd, {passive:true});
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function initMenus(root){
    (root||document).querySelectorAll('[data-arbz-menu]').forEach(function(w){
      if (w.__arbz) return; w.__arbz = true;
      var m = w.querySelector('.arbz-menu');
      w.querySelectorAll('[data-arbz-menu-dir]').forEach(function(b){
        b.addEventListener('click', function(){ m.scrollBy({left: (b.dataset.arbzMenuDir === 'prev' ? -1 : 1) * 260, behavior:'smooth'}); });
      });
    });
  }

  function initHero(root){
    (root||document).querySelectorAll('[data-arbz-hero]').forEach(function(h){
      if (h.__arbz) return; h.__arbz = true;
      var tr = h.querySelector('.arbz-hero__track');
      var slides = tr ? tr.children.length : 0;
      if (!slides) return;
      var dots = h.querySelectorAll('.arbz-hero__dots span');
      var i = 0, timer = null, delay = parseInt(h.dataset.delay || '5000', 10);
      function go(n){ i = (n + slides) % slides; tr.style.transform = 'translateX(' + (document.dir === 'rtl' ? i*100 : -i*100) + '%)'; dots.forEach(function(d,k){ d.classList.toggle('is-active', k === i); }); }
      function play(){ if (h.dataset.autoplay === 'true' && slides > 1){ clearInterval(timer); timer = setInterval(function(){ go(i+1); }, delay); } }
      var p = h.querySelector('[data-arbz-hero-prev]'), n = h.querySelector('[data-arbz-hero-next]');
      if (p) p.addEventListener('click', function(){ go(i-1); play(); });
      if (n) n.addEventListener('click', function(){ go(i+1); play(); });
      var sx = null;
      h.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
      h.addEventListener('touchend', function(e){ if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40){ go(dx < 0 ? i+1 : i-1); play(); } sx = null; });
      go(0); play();
    });
  }

  function toast(html){
    var t = document.querySelector('.arbz-toast');
    if (!t){ t = document.createElement('div'); t.className = 'arbz-toast arbz'; document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-show');
    clearTimeout(t.__h); t.__h = setTimeout(function(){ t.classList.remove('is-show'); }, 3200);
  }

  function refreshCount(){
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('[data-arbz-cart-count]').forEach(function(el){ el.textContent = c.item_count; el.dataset.count = c.item_count; });
      document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){});
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-arbz-atc]');
    if (!b) return;
    e.preventDefault();
    var id = b.dataset.variantId; if (!id) return;
    b.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: parseInt(id,10), quantity: 1}]})})
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(){
        refreshCount();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        toast((b.dataset.added || 'Added to cart') + ' <a href="' + root + 'cart">' + (b.dataset.viewCart || 'View cart') + '</a>');
      })
      .catch(function(){ window.location.href = b.dataset.url || (root + 'cart'); })
      .finally(function(){ b.classList.remove('is-loading'); });
  });

  document.addEventListener('change', function(e){
    var s = e.target.closest('[data-arbz-loc]');
    if (s && s.form) s.form.submit();
  });

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-arbz-totop]')){ e.preventDefault(); window.scrollTo({top:0, behavior:'smooth'}); }
  });

  function initAll(root){ initSliders(root); initMenus(root); initHero(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(); refreshCount(); });
  else { initAll(); refreshCount(); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
